import { render, staticRenderFns } from "./ArticleTGEdit2.vue?vue&type=template&id=2cc4a84f&"
import script from "./ArticleTGEdit2.vue?vue&type=script&lang=js&"
export * from "./ArticleTGEdit2.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTGEdit2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports